// extracted by mini-css-extract-plugin
module.exports = {"arrowsWrapper":"HorizontalScrollButtons_arrowsWrapper__2WJuM","overFlowX":"HorizontalScrollButtons_overFlowX__OsxmX"};